<ng-template #templateEditAdd>
    <form [formGroup]="addSchoolYearForm" (ngSubmit)="onSubmit()" class="col-lg-12">
        <input type="hidden" [formGroup]="addSchoolYearForm" formControlName="id" />
        <div class="row">
            <div class="form-group col-lg-6">
                <h5><label for="codice" class="mandatory">Codice:</label></h5>
                <input [formGroup]="addSchoolYearForm" formControlName="codice" maxlength="255" type="text" value="" class="form-control" placeholder="Inserisci il codice" [ngClass]="{
                    'form-control': true,
                    'is-invalid': submitted && f.codice.errors
                    }" />
                <div *ngIf="submitted && f.codice.errors" class="invalid-feedback" style="display: block;">
                    <div *ngIf="f.codice.errors.required">
                        Campo obbligatorio
                    </div>
                </div>
            </div>
            <div class="form-group col-lg-6">
                <h5><label for="ordine" class="mandatory">Ordine:</label></h5>
                <input [formGroup]="addSchoolYearForm" formControlName="ordine" type="number" value="" class="form-control" placeholder="Inserisci l'ordine" [ngClass]="{
                      'form-control': true,
                      'is-invalid': submitted && f.ordine.errors
                      }" />
                <div *ngIf="submitted && f.ordine.errors" class="invalid-feedback" style="display: block;">
                    <div *ngIf="f.ordine.errors.required">
                        Campo obbligatorio
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <h5><label for="idTipoClassificazione" class="mandatory">Tipo Classificazione:</label></h5>
            <div [ngClass]="{ 'is-invalid': submitted && f.idTipoClassificazione.errors }">
                <ng-select [formGroup]="addSchoolYearForm" formControlName="idTipoClassificazione" [items]="tipiClassificazione" bindValue="id" bindLabel="tipo" (change)="onChangeIdTipoClassificazione($event)" placeholder="Seleziona tipo classificazione">
                </ng-select>
            </div>
            <div *ngIf="submitted && f.idTipoClassificazione.errors" class="invalidFieldMessage" style="display: block;">
                <div *ngIf="f.idTipoClassificazione.errors" class="invalid-feedback" style="display: block;">
                    Campo obbligatorio
                </div>
            </div>
        </div>
        <div class="form-group">
            <h5><label for="descrizione" class="mandatory">Descrizione:</label></h5>
            <textarea [formGroup]="addSchoolYearForm" formControlName="descrizione" rows="5" class="form-control" placeholder="Inserisci la descrizione" [ngClass]="{
                      'form-control': true,
                      'is-invalid': submitted && f.descrizione.errors
                      }"></textarea>
            <div *ngIf="submitted && f.descrizione.errors" class="invalid-feedback" style="display: block;">
                <div *ngIf="f.descrizione.errors.required">
                    Campo obbligatorio
                </div>
            </div>
        </div>
<!--documentazione-->
        <div [hidden]="isInInsert">
            <documentazione-component  [classificazioneId]="classificazioneId"
            [gotoBtnOptions]="{show:false,label:gotoBtnOptions?gotoBtnOptions.label:'Torna a elenco'}"
            >
          </documentazione-component>
        </div>


        <button class="btn btn-lg btn-primary btn-block" type="submit" style="margin:15px 0">
            {{buttonLabel}} 
        </button>
    </form>
</ng-template>
<div class="container sfondo_bianco">
    <hr />
    <accordion [isAnimated]="true">
        <accordion-group heading="Inserisci Nuova Classificazione">
            <ng-container *ngTemplateOutlet="templateEditAdd"></ng-container>
        </accordion-group>
    </accordion>
    <div class="mt-5">

        <ngx-datatable-wrapper #ngxDatatableWrapper [templates]="templateList" style="width: 100%; height: auto;" [dtOptions]="dtOptions">
            <ng-template #btnEditTemplate let-row="row" let-value="value">
                <a [ngClass]="{
        'disabled': loading
        }" class=" border-0 text-center" (click)="onEdit(row)" data-toggle="tooltip" data-placement="top" title="modifica dati">&nbsp;&nbsp;&ensp;<i class="far fa-edit pointer"></i></a>
            </ng-template>
            <ng-template #btnDeleteTemplate let-row="row" let-value="value">
                <a [ngClass]="{
        'disabled': loading
        }" class=" border-0 text-center" (click)="onDelete(row)" data-toggle="tooltip" data-placement="top" title="elimina">&nbsp;&nbsp;&ensp;<i class="far fa-trash-alt pointer"></i></a>
            </ng-template>
        </ngx-datatable-wrapper>
    </div>
</div>
<ng-template #templateModal>
    <div class="modal-header  text-center">
        <h4 class="modal-title pull-left">Modifica classificazione</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
<span aria-hidden="true">&times;</span>
</button>
    </div>
    <div class="modal-body">
        <ng-container *ngTemplateOutlet="templateEditAdd"></ng-container>
    </div>
</ng-template>